import { create } from "zustand";
import { settingsApi } from "../api/settings";

const useSettingsStore = create((set) => ({
  copilotEnabled: true,   // optimistic default — updated after fetch

  fetch: async () => {
    try {
      const { data } = await settingsApi.get();
      set({ copilotEnabled: data.copilot_enabled });
    } catch { /* leave default */ }
  },

  setCopilotEnabled: async (enabled) => {
    set({ copilotEnabled: enabled });   // optimistic
    try {
      await settingsApi.update({ copilot_enabled: enabled });
    } catch {
      set({ copilotEnabled: !enabled }); // roll back on error
    }
  },
}));

export default useSettingsStore;
